export const ImporterActionTypes = {
    SET_DELETED_ACCOUNTS_COUNTS: 'SET_DELETED_ACCOUNTS_COUNTS',
    SET_DELETED_INQUIRIES_COUNTS: 'SET_DELETED_INQUIRIES_COUNTS',
    SET_NEW_NEGATIVE_ACCOUNTS_COUNTS: 'SET_NEW_NEGATIVE_ACCOUNTS_COUNTS',
    SET_NEW_INQUIRIES_COUNTS: 'SET_NEW_INQUIRIES_COUNTS',
    SET_NEW_POSITIVE_ACCOUNTS_COUNTS: 'SET_NEW_POSITIVE_ACCOUNTS_COUNTS',
    SET_UPDATED_ACCOUNTS_COUNTS: 'SET_UPDATED_ACCOUNTS_COUNTS',
};